
import {useContext, useEffect, useMemo, useRef, useState} from "react";
import NavigationBarVertial from "../components/NavigationBarVertical";
import RequestsList from "../components/requests-list/RequestsList";
import Editor from "../components/Editor";
import {appContext} from "../state";
import Clone from "../utils/clone";
import {Button, Input, InputNumber, Tabs} from "antd";
import HeadersTabTable from "../components/requests-list/HeadersTabTable";
import QueryTabTable from "../components/requests-list/QueryTabTable";
import BodyTabEditor from "../components/requests-list/BodyTabEditor";
import Rules from "../components/Rules";
import {GlobalOutlined} from "@ant-design/icons";
import {getRequestByKey, getRequestKey} from "../utils/requests";
import {send} from "../utils/websocket";
import app from "../App";
import InputStatusCode from "../components/inputs/InputStatusCode";


function Home(props) {

    const {appStateContextValue} = useContext(appContext);
    const [appState, setAppState] = appStateContextValue
    const appStateRef = useRef(appState); // inside the event listeners like for sockets/click listeners it will keep the appState defined at the moment the listener was created. This can be outdated

    const [statusCode, setStatusCode] = useState('');
    const [didResize, setDidResize] = useState(null);
    /*const activeRequest = useMemo(() => {
        //console.log('ACTIVE_REQUEST_MEMO_CHANGE',appStateRef.current.activeRequestID)
        return appStateRef.current.requests.find( (req) => req.id === appState.activeRequestID)
    }, [appStateRef.current.activeRequestID]);*/


    useEffect(() => {
        //console.log('appState',appState)
        if (appState.requests.length > 0) {
            let newAppState = Clone(appStateRef.current)
            newAppState.activeRequestID = appState.requests[0].id
            setAppState(newAppState)
        }

       /* setTimeout(() => {
            let newAppState = Clone(appStateRef.current)
            newAppState.activeRequestID = '123'
            setAppState(newAppState)
        },1000)/**/

    }, []);

    useEffect(() => {
        console.log('APP_STATE_CHANGED',appState.view,"|",appState.activeRequestID,"|",appStateRef.current.activeRequestID)
        if (appState.menuBarButtons['left'] !== appStateRef.current.menuBarButtons['left']) {
            setDidResize(!didResize)
        }
        appStateRef.current = appState
    },[appState]);

    function onEditorChanged (newBody) {
        let newAppState = Clone(appStateRef.current)
        let activeRequest = newAppState.requests.find( (req) => req.id === appState.activeRequestID )
        console.log('ACTIVE_REQ:',activeRequest)
        newAppState.editorBody = newBody // IMPORTANT
        if (activeRequest) {
            activeRequest.response.body = newBody
            updateCacheOnServer(activeRequest)
        }
        setAppState(newAppState)
    }

    function onStatusCodeChanged (newStatusCode,isValid) {
        if (!newStatusCode || isNaN(newStatusCode)) {
            return
        }
        let newAppState = Clone(appStateRef.current)
        let activeRequestIdx = newAppState.requests.findIndex( (req) => req.id === appState.activeRequestID )
        if (activeRequestIdx !== -1) {
            if (isValid) {
                console.log('newStatusCode',newStatusCode)
                newAppState.requests[activeRequestIdx].response.status = newStatusCode
                updateCacheOnServer(newAppState.requests[activeRequestIdx])
                setAppState(newAppState)
            }
            setStatusCode(newStatusCode)
        }
    }

    function onHeadersChanged (headers) {
        console.log('ON_HEADER_CHANGED',headers)
        let newAppState = Clone(appStateRef.current)
        let activeRequestIdx = newAppState.requests.findIndex( (req) => req.id === appState.activeRequestID )
        console.log('ACTIVE_REQ:',activeRequestIdx, appState.activeRequestID)
        if (activeRequestIdx !== -1) {
            let headersObject = {}
            headers.forEach( (header) => {
                headersObject[header.key] = header.value
            })
            newAppState.requests[activeRequestIdx].response.headers = headersObject
            updateCacheOnServer(newAppState.requests[activeRequestIdx])
            setAppState(newAppState)
        }
    }

    function updateCacheOnServer (activeRequest) {
        //console.log('NEW_BODY',activeRequest.response.body)
        send({
            action:'UPDATE_CACHE',
            subdomain:appState.mockAPI,
            response:{
                body:activeRequest.response.body,
                headers:activeRequest.response.headers,
                status:activeRequest.response.status
            },
            request:activeRequest.request
        });
    }
    function onRowSelected (request) {
        console.log('onRowSelected',request)
        let newAppState = Clone(appStateRef.current)
        newAppState.activeRequestID = request.id
        if (request.response) {
            //console.log('STATUS',request.response.status)
            setStatusCode(request.response.status)
            newAppState.editorHeaders = request.response.headers
            newAppState.editorBody = request.response.body
            newAppState.editorBodyID = request.response.id
        }
        setAppState(newAppState)
    }

    function onRowDelete (request) {
        console.log('onRowDelete',request.id,appStateRef.current.requests.length, request)
        //let newAppState = {...appStateRef.current}
        let newAppState = Clone(appStateRef.current)
        newAppState.requests = newAppState.requests.filter(req => req.id !== request.id)
        console.log('AFTER',newAppState.requests.length)
        setAppState(newAppState)
    }

    function getResponseTabs ()  {

        let headers = Object.keys(appState.editorHeaders || {}).map((key) => {
            return {key: key, value: appState.editorHeaders[key]}
        });
        //console.log('RENDER_ACTIVE_REQ:',activeRequest?.id,"|",appState.editorBodyID,"|",appState.editorBody)
        //  {appState.editorBodyID ? <div>{appState.editorBodyID}</div> : false}
        const items = [
            {
                key: 'body',
                label: 'Body',
                children: <Editor key={"editor_"+appState.editorBodyID} didResize={didResize} onEditorChanged={onEditorChanged} contentType={appState.editorContentType} body={appState.editorBody}></Editor>
            },
            {
                key: '2',
                label: 'Headers',
                children: <div>
                    <HeadersTabTable onHeadersChanged={onHeadersChanged} canEdit={true} headers={headers || []}></HeadersTabTable>
                </div>,
            }
        ];
        return items
    }

    const onTabChange = (key) => {
        console.log(key);
    }

    const statusCodeInfo = <div className="tab-bar-extra">
        <InputStatusCode onChange={onStatusCodeChanged} statusCode={statusCode}></InputStatusCode>
    </div>

    const respondToLiveModeRequest = async () => {
        const url = process.env.REACT_APP_SERVER_API_HOST+"/user/respond-to-live-mode-request";
        try {
            let body = {
               response:{
                   headers:[
                       // 'Content-Type':'application/json'
                   ],
                   status:statusCode || 200,
                   data:appState.editorBody
               }
            }
            let headers = new Headers();
            headers.append("token", localStorage.getItem('token'));
            headers.append('content-type', 'application/json')
            let requestOptions = {method: 'POST', headers: headers, body:JSON.stringify(body) };
            const response = await fetch(url,requestOptions);
            if (!response.ok) {
                console.error(new Error(`Response status: ${response.status}`))
            }
            const json = await response.json();
            console.log('RESPONSE:',json)
        } catch (error) {
            console.error(error.message);
        }
    }

    return (
        <div data-left-tab={!!appState.menuBarButtons['left']} data-right-tab={!!appState.menuBarButtons['right']} className="view home">
            {appState.menuBarButtons.left ? <RequestsList onRowSelected={onRowSelected} onRowDelete={onRowDelete}></RequestsList> : false}
            {/*appState.menuBarButtons.center ? <Rules></Rules> : false*/}
            {/*activeRequest ? <div key={'bla'+activeRequest.id}>{activeRequest.id}</div> : <div>-</div>*/}
            {appState.menuBarButtons.right ?
                <div className="details">
                    <Tabs defaultActiveKey="1" tabBarExtraContent={statusCode !== '' ? statusCodeInfo : false}  items={getResponseTabs()} onChange={onTabChange}></Tabs>
                    {appState.isLiveModeActive ? <Button onClick={respondToLiveModeRequest} className="respond-to-live-mode" type="primary">Respond</Button> : false}
                </div> : false}
        </div>
    );
}

export default Home;
